import { render, staticRenderFns } from "./error.vue?vue&type=template&id=12b340c8&scoped=true&"
var script = {}
import style0 from "./error.scss?vue&type=style&index=0&id=12b340c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b340c8",
  null
  
)

export default component.exports